import { computed, type ComputedRef } from 'vue'
import GatPhoneEditFunctions from '../functions/GatPhoneEditFunctions'

export function useCountryDialNumber(
  countryCode: ComputedRef<string | undefined>
) {
  function getCountryDial(countryCodeParam: string | undefined): string {
    if (!countryCodeParam) {
      return ''
    }
    const countryInfo = GatPhoneEditFunctions.GetAllCountryNumbers().find(
      (item) => item.CountryCode === countryCodeParam
    )
    if (countryInfo) {
      return `+${countryInfo.DialCode}`
    }
    return ''
  }

  const countryDialNumber = computed((): string =>
    getCountryDial(countryCode.value)
  )

  return {
    countryDialNumber
  }
}
